import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const orderApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/order",
      params,
    }),
  findOne: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/order/${id}`,
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/order/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/order/${id}`,
      method: "delete",
    }),
  importExcel: (file: File): AxiosPromise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    return request({
      url: "/v1/admin/order/import",
      method: "post",
      data: formData,
      timeout: 120000,
    });
  },
  importDebtExcel: (file: File): AxiosPromise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    return request({
      url: "/v1/admin/order/debt/import",
      method: "post",
      data: formData,
      timeout: 120000,
    });
  },
};
